import React from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { ProfileSortKey, SortDir } from '../../lib/adminTableSort';

type Props = {
  label: string;
  sortKey: ProfileSortKey;
  activeKey: ProfileSortKey;
  dir: SortDir;
  onSort: (key: ProfileSortKey) => void;
  className?: string;
  align?: 'left' | 'right';
};

const SortableTh: React.FC<Props> = ({
  label,
  sortKey,
  activeKey,
  dir,
  onSort,
  className = '',
  align = 'left',
}) => {
  const active = activeKey === sortKey;
  const Icon = !active ? ArrowUpDown : dir === 'asc' ? ArrowUp : ArrowDown;

  return (
    <th className={`${align === 'right' ? 'text-right' : 'text-left'} px-4 py-3 ${className}`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`inline-flex items-center gap-1.5 font-medium transition-colors hover:text-white ${
          active ? 'text-white' : 'text-dark-300'
        }`}
        aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      >
        {label}
        <Icon className={`h-3.5 w-3.5 shrink-0 ${active ? 'text-primary-400' : 'text-dark-500'}`} />
      </button>
    </th>
  );
};

export default SortableTh;
